<template>
  <div
    id="index"
    v-cloak
  >
    <!-- <Hezuo></Hezuo> -->

    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i
          class="esc"
          @click="goBackward"
        ><img
            src="@/assets/img/esc_fan.png"
            alt=""
          ></i>
        <h4 class="header_title">基本信息</h4>
        <span
          class="rigth_button"
          @click.stop="state = true"
          v-if="!state"
        >
          编辑
        </span>
        <span
          class="rigth_button"
          v-else
          @click.stop="state = false"
        >
          取消
        </span>
      </header>
      <!-- 内容 -->
      <div
        class="view_center"
        v-if="!state"
      >
        <div class="view_li flex_center portrait">
          <span class="li_title">头像：</span>
          <div class="li_text">
            <img
              :src="upImage===''?user.image:upImage"
              alt=""
            >
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">登录名：</span>
          <div class="li_text">
            {{user.mobile}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">昵称：</span>
          <div class="li_text">
            {{user.username}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">邮箱：</span>
          <div class="li_text">
            {{user.email}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">真实姓名：</span>
          <div class="li_text">
            {{user.realname}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">性别：</span>
          <div class="li_text">
            <span v-if="user.sex == 0">保密</span>
            <span v-else-if="user.sex == 1">男</span>
            <span v-else>女</span>
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">生日：</span>
          <div class="li_text">
            {{user.birth}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">工作单位：</span>
          <div class="li_text">
            {{user.company}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">职称：</span>
          <div class="li_text">
            {{user.professor}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">科室：</span>
          <div class="li_text">
            {{user.office}}
          </div>
        </div>
        <div class="view_li flex_center" style="padding:0">
          <span class="li_title">执医证：</span>
          <div class="li_text">
            <img
              :src="user.cert" style="width:120px;height:120px" @click="bigImg(user.cert)"
              alt=""
            >
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">邮寄地址：</span>
          <div class="li_text">
            {{user.address}}
          </div>
        </div>
        <div class="view_li flex_between">
          <span class="li_title">会员邀请码：</span>
          <div class="li_text">
            {{user.code}}
          </div>
        </div>
      </div>
      <!-- 修改数据 -->
      <div
        class="from_div user_div view_center"
        v-if="state"
      >
        <div class="user_li flex_center portrait">
          <span class="li_title">头像：</span>
          <div
            class="li_text"
            @click.stop="upImgFun"
          >
            <el-upload
              class="avatar-uploader flex_start"
              :action="URL + 'upload'"
              :show-file-list="false"
              :before-upload="handleAvatarPreview"
              :on-success="handleAvatarSuccess"
            >
              <img
                :src="upImage"
                alt=""
              >
              <span>点击上传头像</span>
            </el-upload>
          </div>
          <span
            class="moren"
            @click="show3 = !show3"
          >选择默认头像</span>

        </div>
        <div style=" margin-top: 18px;">
          <transition name="el-zoom-in-center">
            <div
              class="morentou "
              v-show="show3"
            >
              <img
                :src="item.src"
                alt=""
                v-for="(item,index) in imgarr"
                :key="index"
                @click="checkimg(item.src)"
              >
            </div>
          </transition>
        </div>
        <div class="user_li flex_center">
          <span class="li_title">登录名：</span>
          <div class="li_text">{{user.mobile}}</div>
        </div>
        <div class="user_li flex_center">
          <span class="li_title">昵称：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="username"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
          </div>
        </div>
        <div class="user_li flex_center">
          <span class="li_title">邮箱：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="email"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
          </div>
        </div>
        <div class="user_li  flex_start">
          <span class="li_title">真实姓名：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="realname"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
            <el-select
              v-model="power_see.realname"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="user_li flex_center radio_li">
          <span class="li_title">性别：</span>
          <div class="li_text flex_start">

            <el-radio-group v-model="sex">
              <el-radio label="0">保密</el-radio>
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="user_li flex_start radio_li ">
          <span class="li_title">生日：</span>
          <div class="li_text">

            <el-date-picker
              v-model="birth"
              class="picker_div"
              size="mini"
              editable="false"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <el-select
              v-model="power_see.birth"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="user_li flex_start">
          <span class="li_title">工作单位：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="company"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
            <el-select
              v-model="power_see.cpmpany"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="user_li flex_start">
          <span class="li_title">职称：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="professor"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
            <el-select
              v-model="power_see.professor"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="user_li flex_start">
          <span class="li_title">科室：</span>
          <div class="li_text ">
            <el-col :span="24">
              <el-input
                v-model="office"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
            <el-select
              v-model="power_see.office"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="user_li flex_center">
          <span class="li_title">执医证：</span>
          <div
            class="li_text"
            @click.stop="upImgFun"
          >
            <el-upload
              class="avatar-uploader flex_start"
              :action="URL + 'upload'"
              :show-file-list="false"
              :before-upload="handleAvatarPreview"
              :on-success="handleCertSuccess"
            >
              <img
                :src="cert" alt="" style="width:150px;height:150px"
              >
              <span>点击上传执医证</span>
            </el-upload>
          </div>

        </div>
        <div class="user_li flex_center">
          <span class="li_title">邮寄地址：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="address"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
          </div>
        </div>
        <div class="user_li flex_center">
          <span class="li_title">会员邀请码：</span>
          <div class="li_text">
            <el-col :span="24">
              <el-input
                v-model="invite"
                size="mini"
                placeholder="请输入邀请码"
              ></el-input>
            </el-col>
          </div>
        </div>
        <el-button
          class="save"
          @click.stop="saveUser"
          type="danger"
        >保存</el-button>
      </div>
        <div id="overlay" style="display:none;" @click="closebig"></div>
    </div>
  </div>
</template>

<script>
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";
import Hezuo from '@/components/tool/m_hezuo.vue'

let layerOpen;
export default {
  name: "index",
  data () {
    return {
      imgarr: [{ src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/95fad0d12ae4ecdf9bad89fb417cd7ac.jpg' },
      { src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/5bdd3d87b1e5888525d6e2e27483f27f.jpg' },
      { src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/e85e417187067af11f3daddeee5497d3.jpg' },
      { src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/c1a1210c74b91c34df547cea7906e3f0.jpg' },
      { src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/6df03bf9d9da98bd06121ebb79a391fe.jpg' },
      { src: 'http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/d54b88d68d257ce53487f7a36810afd3.jpg' },
      ],
      show3: false,
      URL: this.$URL,
      state: false,//管理状态
      user: {},//用户信息

      username: '',//昵称
      realname: '',//真实姓名
      sex: '0',//0保密 1男 2女
      birth: '',//生日
      company: '',//工作单位
      professor: '',//职称
      office: '',//科室
      power_see: {},//可见
      upImage: '',
      cert:'',
      email: '',//邮箱
      address: '',//邮寄地址
      invite: '',//会员邀请码
      options: [{
        value: '0',
        label: '仅自己可见'
      }, {
        value: '1',
        label: '所有人可见'
      }, {
        value: '2',
        label: '我关注的人可见'
      }],
      is_app: this.$store.state.is_app,
    };
  },
  computed: {},
  components: {
    Hezuo
  },
  watch: {

  },
  methods: {
     closebig(){
                overlay.style.display = 'none';
            },
    bigImg(img){
        var overlay = document.getElementById('overlay');
        overlay.style.display = 'flex';
        overlay.innerHTML = '<img src="' + img + '" alt="Large image" style="max-width:80%">';
    },
    upImgFun () {
       
      if (this.is_app) {
        let that = this;
        let index = layer.open({
          title: [
            '选择方式',
            'background-color: #FF4351; color:#fff;'
          ]
          , content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">拍照</div>' +
            '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">相册</div>'
        });
        $('#session').click(() => {//拍照
          android.pictureMethod(1);
          layer.close(index);
        })
        $('#circle').click(() => {//相册
          android.pictureMethod(2);
          layer.close(index);
        })
      }
    },
    upImg (img) {
      this.upImage = img;
    },
    handleAvatarPreview () {//开始上传
       
      layerOpen = layer.open({
        type: 2
        , content: '上传中'
      });
    },
    
    handleAvatarSuccess (res, file) {
      layer.close(layerOpen);
      layer.open({
        content: "上传完成",
        time: true,
        skin: "msg"
      });
      this.upImage = res.data;
    },
    handleCertSuccess(res, file) {
      layer.close(layerOpen);
      layer.open({
        content: "上传完成",
        time: true,
        skin: "msg"
      });
      this.cert = res.data;
    },
    checkimg (src) {
      this.upImage = src;

    },
    goBackward () {//返回上一页
      this.$router.go(-1)
    },
    saveUser () {//保存修改
      let that = this;
      for (var key in this.power_see) {
        this.options.forEach(element => {
          if (element.value == this.power_see[key] || element.label == this.power_see[key]) {
            that.power_see[key] = element.value;
          }
        })
      }

      this.$post('user_modify', {
        member_id: this.user.id,
        sex: this.sex,
        username: this.username,
        realname: this.realname,
        birth: this.birth,
        company: this.company,
        professor: this.professor,
        office: this.office,
        power_see: JSON.stringify(this.power_see),
        userimage: this.upImage,
        cert:this.cert,
        email: this.email,
        address: this.address,
        invite: this.invite,
      }).then(res => {
        layer.open({
          content: res.msg
          , time: 1
          , skin: 'msg'
        });
        if (res.code == 200) {
          that.user = res.data;
          that.getUser();
          setTimeout(() => {
            that.state = false;
          }, 1000)
        }
      }).catch(res => {
        layer.open({
          content: res.message
          , time: 2
          , skin: 'msg'
        });
      })
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();

    },
    assignment () {//赋值
      this.username = this.user.username;
      this.realname = this.user.realname;
      this.sex = this.user.sex.toString();
      this.birth = this.user.birth;
      this.company = this.user.company;
      this.professor = this.user.professor;
      this.office = this.user.office;
      this.upImage = this.user.image;
      this.cert = this.user.cert
      this.email = this.user.email;
      this.address = this.user.address;
      this.invite = this.user.code;
      if (this.user.power_see) {
        this.power_see = JSON.parse(this.user.power_see);
        for (var key in this.power_see) {
          this.power_see[key] = this.options[this.power_see[key]].label;
        }
      }

    },

  },
  mounted () {
    window.upImg = this.upImg;
    this.user = this.USER();
    this.assignment();
    this.getUser();
    this.getShare();
    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }

  }
};
</script>
<style>
#overlay {
    margin: 0 auto;
    width: 100%;
    padding: 13px 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}
.avatar-uploader input.el-upload__input {
  display: none;
}

.picker_div.el-input.el-input--prefix {
  width: 100% !important;
}
</style>
<style scoped>
html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
.view_center {
  padding: 1rem 1.5rem;
}

.view_center .view_li {
  padding: 1.5rem 0;
  margin-bottom: 0.5rem;
  border-bottom: 0.05rem solid #f1f1f1;
}

.view_li .li_title {
  width: 9rem;
  white-space: nowrap;
  font-size: 1.4rem;
  color: #333;
  text-align: justify;
  text-justify: inter-ideograph;
}

.view_li .li_text {
  flex: 1;
  margin-left: 1rem;
}

.user_div .user_li {
  margin-top: 18px;
}

.user_div .user_li .li_title {
  text-align: left;
  width: 9rem;
  white-space: nowrap;
  font-size: 1.4rem;
  color: #333;
  height: 2.8rem;
  line-height: 2.8rem;
}

.user_div .user_li .li_text {
  font-size: 16px;
  color: #333;
  flex: 1;
}

.radio_li .gou_li {
  margin: 0 10px;
}

.radio_li .gou_li > i {
  width: 13px;
  margin-right: 6px;
}

.user_li .el-select {
  flex: 1;
  margin-top: 1rem;
  font-size: 1rem !important;
}

.user_li .el-select input {
  font-size: 1rem !important;
}

input {
  border-color: #dcdfe6;
}

input:focus,
select:focus {
  border: 1px solid #dcdfe6 !important;
}

.save {
  display: block;
  width: 80%;
  margin: 5rem auto 0 auto;
  height: 4.5rem;
  line-height: 4.5rem;
  padding: 0;
  border-right: 0.2rem;
  font-size: 1.6rem;
}

.portrait .li_text img {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  overflow: hidden;
  object-fit: contain;
}

.avatar-uploader span {
  font-size: 1.2rem;
  color: #a1a1a1;
  margin-left: 1rem;
}
.moren {
  font-size: 1.2rem;
  color: #a1a1a1;
}
.morentou {
  widows: 100%;
  display: flex;
  height: 53px;
  justify-content: space-around;
}
.morentou img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.clearfix:after {
  visibility: hidden;
  clear: both;
  display: block;
  content: ".";
  height: 0;
}

.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_personal.vue